type TyTimelineItemContentProfileProps = {
  dateCreated: string;
  createdBy: string;
};

export const TyTimelineItemContentProfile = ({
  dateCreated,
  createdBy,
}: TyTimelineItemContentProfileProps) => {
  return (
    <div className="mt-[27px] flex flex-row">
      <div className="flex flex-col">
        <span className="text-body-2-lg font-semibold">
          {createdBy}
        </span>
        <span className="text-caption-md">{dateCreated}</span>
      </div>
    </div>
  );
};
